const useImagePreviewDialogStyles = () => {
    return {
        previewImageDialogStyles: {
            display: 'flex',
        },
        imageStyles: {
            width: '100%',
            height: 'auto',
            objectFit: 'cover'
        },
        dismissIconBtnStyles: {
            position: 'absolute',
            top: 1,
            right: 1,
        }
    };
};
export default useImagePreviewDialogStyles;
